// Jobs — route /jobs
//
// Thin wrapper around the canonical JobsPage from admin-design/_common/jobs.
// Backed by the saas-common/jobruns audit log mounted at /api/admin/jobs.
//
// Add per-job display labels here as the project grows; unknown keys fall
// through to the raw job name.

import { JobsPage } from '@/admin-design/_common/jobs'

const labels: Record<string, string> = {
  session_purge: 'Session purge',
}

export default function Jobs() {
  return <JobsPage labels={labels} />
}
